<template>
  <div class="page page-routes">

    <transition name="appear">
    <route-details
      v-if="showDetails && pageReady"
      :isFuture="isFuture"
      :routesData="routesData">
    </route-details>
    </transition>

    <div v-if="!showDetails">
      <!-- <h2 v-if="isFuture">Future Routes</h2>
      <h2 v-else>Routes</h2>     -->
      <routes-search-autocomplete
        :isFuture="isFuture"
        :routesData="routesData">
      </routes-search-autocomplete>

      <transition name="appear">
        <routes-list
          :isFuture="isFuture"
          :routesData="routesData">
        </routes-list>
      </transition>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import RoutesSearchAutocomplete from '@/components/RoutesSearchAutocomplete.vue'
import RoutesList from '@/components/RoutesList.vue'
import RouteDetails from '@/components/RouteDetails.vue'
import mixinCommon from '../mixins/common'
import routesInfo from '../data/routes-info.json'

export default {
  name: 'routes-all',
  components: {
    RoutesSearchAutocomplete, RoutesList, RouteDetails
  },
  mixins: [mixinCommon],
  data () {
    return {
      isFuture: window.showFutureRoutes || false,
      pageReady: false,
      routesBus: [],
      routesLightRail: [],
    }
  },
  computed: {
    routesData () {
      if (!window.drupalSettings) {
        window.drupalSettings = {
          sdg: {
            routes: routesInfo
          }
        }
      }
      return window.drupalSettings.sdg.routes;
    },
    routeNo () {
      if (this.$route.params.routeNo === 'undefined') {
        return false
      }
      return this.$route.params.routeNo || false
    },
    showDetails () {
      // return this.routeType && this.routeNo
      return this.routeNo
    }
  },
  mounted () {
    this.pageReady = true
  }
}
</script>
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/views/RoutesAll.vue